export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function getButtonStyles(theme = "light") {
  const dark = theme === "dark";

  return {
    base: cn(
      "inline-flex items-center justify-center gap-2 rounded-2xl",
      "font-semibold transition-all duration-200",
      "disabled:cursor-not-allowed disabled:opacity-60",
      "focus:outline-none focus:ring-2 focus:ring-offset-2",
      dark ? "focus:ring-offset-slate-950" : "focus:ring-offset-white"
    ),

    sizes: {
      xs: "h-8 px-3 text-xs",
      sm: "h-9 px-3.5 text-sm",
      md: "h-10 px-4 text-sm",
      lg: "h-11 px-5 text-sm",
      xl: "h-12 px-6 text-base",
      icon: "h-10 w-10",
    },

    primary: dark
      ? "bg-blue-600 text-white shadow-sm hover:bg-blue-500 hover:shadow-md focus:ring-blue-500"
      : "bg-blue-500 text-white shadow-sm hover:bg-blue-600 hover:shadow-md focus:ring-blue-500",

    secondary: dark
      ? "bg-slate-900 text-slate-100 border border-slate-700 hover:bg-slate-800 shadow-sm focus:ring-slate-500"
      : "bg-white text-slate-700 border border-slate-200 hover:bg-slate-50 shadow-sm focus:ring-slate-400",

    ghost: dark
      ? "bg-transparent text-slate-200 hover:bg-slate-800 border border-transparent focus:ring-slate-500"
      : "bg-transparent text-slate-700 hover:bg-slate-100 border border-transparent focus:ring-slate-400",

    success: dark
      ? "bg-emerald-600 text-white shadow-sm hover:bg-emerald-500 hover:shadow-md focus:ring-emerald-500"
      : "bg-emerald-500 text-white shadow-sm hover:bg-emerald-600 hover:shadow-md focus:ring-emerald-500",

    danger: dark
      ? "bg-rose-600 text-white shadow-sm hover:bg-rose-500 hover:shadow-md focus:ring-rose-500"
      : "bg-rose-500 text-white shadow-sm hover:bg-rose-600 hover:shadow-md focus:ring-rose-500",

    warning: dark
      ? "bg-amber-500 text-slate-950 shadow-sm hover:bg-amber-400 hover:shadow-md focus:ring-amber-400"
      : "bg-amber-500 text-white shadow-sm hover:bg-amber-600 hover:shadow-md focus:ring-amber-500",

    softDanger: dark
      ? "border border-rose-800 bg-rose-950/30 text-rose-300 hover:bg-rose-950/50 focus:ring-rose-500"
      : "border border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100 focus:ring-rose-400",

    softSuccess: dark
      ? "border border-emerald-800 bg-emerald-950/30 text-emerald-300 hover:bg-emerald-950/50 focus:ring-emerald-500"
      : "border border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 focus:ring-emerald-400",
  };
}

export function buttonClass({
  theme = "light",
  variant = "secondary",
  size = "md",
  className = "",
} = {}) {
  const styles = getButtonStyles(theme);
  return cn(styles.base, styles.sizes[size] || styles.sizes.md, styles[variant] || styles.secondary, className);
}
